import React from 'react'

function Hero() {
  return (
    <>
    <div className='box'>
        <div className='left-side'>HackScript <br></br>
      <p1 className='text-blue-900'>Community</p1>   
      <br></br>
      <p1 className = "smtext">Learn |  Code | Coffee </p1>
      <div className='btn'>        <a href="https://chat.whatsapp.com/ID7GctzP5dfLuEXPNsv9kq" className="relative px-5 py-3 overflow-hidden font-medium text-gray-600 bg-gray-100 border border-gray-100 rounded-lg shadow-inner group">
<span className="absolute top-0 left-0 w-0 h-0 transition-all duration-200 border-t-2 border-blue-600 group-hover:w-full ease"></span>
<span className="absolute bottom-0 right-0 w-0 h-0 transition-all duration-200 border-b-2 border-gray-600 group-hover:w-full ease"></span>
<span className="absolute top-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-greeny-600 group-hover:h-full ease"></span>
<span className="absolute bottom-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-greeny-600 group-hover:h-full ease"></span>
<span className="absolute inset-0 w-full h-full duration-300 delay-300 bg-blue-600 opacity-0 group-hover:opacity-100"></span>
<span className="relative transition-colors duration-300 delay-200 group-hover:text-white ease">Join Community</span>
</a></div>
        </div>

        <div className='right-side'><img src='cups.jpg'></img></div>
       
    </div>

<div className='blackbox'>
<img src='hack-black.png'></img>
  <p1 className = "text"> Developer Terminal : A New Place for Developers 
 <div className='btns'> <a href="https://earnest-starship-32aaae.netlify.app/" className="relative px-5 py-3 overflow-hidden font-medium text-gray-600 bg-gray-100 border border-gray-100 rounded-lg shadow-inner group">
<span className="absolute top-0 left-0 w-0 h-0 transition-all duration-200 border-t-2 border-blue-600 group-hover:w-full ease"></span>
<span className="absolute bottom-0 right-0 w-0 h-0 transition-all duration-200 border-b-2 border-gray-900 group-hover:w-full ease"></span>
<span className="absolute top-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-blue-600 group-hover:h-full ease"></span>
<span className="absolute bottom-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-blue-600 group-hover:h-full ease"></span>
<span className="absolute inset-0 w-full h-full duration-300 delay-300 bg-gray-900 opacity-0 group-hover:opacity-100"></span>
<span className="relative transition-colors duration-300 delay-200 group-hover:text-white ease">Termn-X</span>
</a>

</div>
</p1>     

   </div>
           

    </>
  )
}

export default Hero